import React, { useState, useEffect } from 'react';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import Select from 'react-select';
import CreatePage from '../../../composents/CreatePage';

const title = 'Entities';
const headers = {
	icon: 'feather icon-plus',
	title: title,
	description: 'creation of new entity',
	breadcrumbs: [
		{
			title: title,
			link: '/hydrodrip/hd_entities',
		},
	],
};

export default function CreateHdEntity() {
	const [loader, setLoader] = useState(false),
		[errors, setErrors] = useState({}),
		[city, setCity] = useState(),
		[cities, setCities] = useState([]),
		[country, setCountry] = useState(),
		[countries, setContries] = useState([]);

	async function onGet() {
		let cus = await resources.country
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});

		if (cus.status === 200) {
			let a = [];
			cus.data.docs.forEach((el) => {
				a.push({
					value: el.id,
					label: el.name,
				});
			});
			setContries(a);
		}
		let cit = await resources.city
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});

		if (cit.status === 200) {
			let a = [];
			cit.data.docs.forEach((el) => {
				a.push({
					value: el.id,
					label: el.name,
					country: el?.country?.id,
				});
			});
			setCities(a);
		}
	}

	useEffect(() => {
		onGet();
	}, []);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		if (city) object.city = city.value;
		setLoader(true);
		setErrors({});
		let res = await resources.entity
			.create(object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/hydrodrip/hd_entities');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	const filterCity = () => {
		let all_cities = [];
		if (country) {
			all_cities = cities.filter((e) => e.country === country.value);
		}
		return all_cities;
	};

	return (
		<CreatePage show_error={errors['not_autorized']} headers={headers}>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Country name{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={(e) => {
											setCountry(e);
											setCity(null);
										}}
										options={countries}
										required
										isSearchable
										isClearable
									/>
								</div>

								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										City name{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										required
										onChange={(e) => setCity(e)}
										options={filterCity()}
										value={city}
										isSearchable
										isClearable
										className={
											errors['city'] ? ' is-invalid' : ''
										}
									/>
									{errors['city'] && (
										<div className="invalid-feedback">
											{errors['city']}
										</div>
									)}
								</div>

								<Field
									name="name"
									className="mb-3"
									error={errors['name']}
									required
								>
									Entity name
								</Field>

								<Field
									name="description"
									type="textarea"
									error={errors['description']}
									className="mb-3"
								>
									Description
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary"
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</CreatePage>
	);
}
